<template>
<div>
  <div class="bgcover">
    <div class="bcover"></div>
    <div class="top">
      <h2 class="text-center font-moul" style="color:#ffcc00">
        សូមស្វាគមន៍ <span class="fw-bold" style="color:white;font-family: 'Rubik';">Welcome</span>
      </h2>
      <h3 class="text-center lh-lg fw-bold">ប្រព័ន្ធចុះឈ្មោះ និងការបង់ថ្លៃតាមអនឡាញ សម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តក្នុងវិស័យមូលបត្រ</h3>
      <h4 class="text-center lh-lg" style="font-family: 'Rubik';">ONLINE REGISTRATION AND PAYMENT FOR TRAINING AND EXAMINATION AND CONTINUING PROFESSIONAL EDUCATION (CPE) IN SECURITIES SECTOR</h4>
      <div class="text-center p-5" style="margin-top:50px;">
        <button
          type="button"
          class="btn btn-warning fw-bold"
          style="font-size:16px;"
          @click="clickRegister"
        >
          {{$t("message.registration_training")}} <i class="fas fa-pencil-alt"></i>
        </button>
      </div>
    </div>
  </div>
    <div class="bg-gray">
      <div class="container">
        <div class="row" style="padding:50px 25px;">
          <div class="col-sm-6">
            <iframe width="100%" height="315" src="https://www.youtube.com/embed/Adehq3jLwEE?si=udRPWAz6i2k7Vi1j" title="ការចុះឈ្មោះ និងបង់ថ្លៃតាមអនឡាញ សម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្ត" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          <div class="col-sm-6">
            <h2 class="text-center" style="padding:25px;font-weight:bold;">របៀបប្រើប្រាស់</h2>
            <!--  eslint-disable no-use-before-define  -->
            <p class="pf">ការចុះឈ្មោះ និងបង់ថ្លៃតាមអនឡាញ សម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តតាមរយះ ប្រព័ន្ធចុះឈ្មោះ និងការបង់ថ្លៃតាមអនឡាញ សម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តក្នុងវិស័យមូលបត្រ</p>
            <!--  eslint-enable no-use-before-define  -->
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="container">
        <div class="row" style="padding:25px;">
          <h2 class="text-center" style="padding:25px;font-weight:bold;">វគ្គបណ្តុះបណ្តាលនិងការប្រឡងក្នុងវិស័យមូលបត្រ</h2>
          <!--  eslint-disable no-use-before-define  -->
          <p class="pf">បុគ្គលដែលតម្រូវឱ្យចូលរួមវគ្គបណ្តុះបណ្តាល និងការប្រឡងក្នុងវិស័យមូលបត្រនិងសាធារណជនទូទៅដែលមានបំណងចូលរួមវគ្គបណ្តុះបណ្តាលនិងការប្រឡងក្នុងវិស័យមូលបត្រ ត្រូវដាក់ពាក្យស្នើសុំចុះឈ្មោះមក <b>(ន.ម.ក.)</b> ទៅតាមទម្រង់ផ្ដល់ឯកសារភ្ជាប់ និងបង់ថ្លៃចុះឈ្មោះដែលកំណត់ដោយ <b>ន.ម.ក.</b>។</p>
          <!--  eslint-enable no-use-before-define  -->
        </div>
      </div>
    </div>
    <div class="bg-gray">
      <div class="container">
        <div class="row" style="padding:25px;">
          <h2 class="text-center" style="padding:25px;font-weight:bold;">កម្មវិធីអប់រំវិជ្ជាជីវៈបន្តក្នុងវិស័យមូលបត្រ</h2>
          <!--  eslint-disable no-use-before-define  -->
          <p class="pf">ដើម្បីបន្តសុពលភាពលទ្ធផលប្រឡង ឬលទ្ធផលនៃការចូលរួមកម្មវិធីអប់រំវិជ្ជាជីវៈបន្ត បុគ្គលដែលត្រូវបន្តសុពលភាព ត្រូវដាក់ពាក្យស្នើសុំចុះឈ្មោះចូលរួមកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តមក <b>ន.ម.ក.</b> ទៅតាមទម្រង់ ផ្ដល់ ឯកសារភ្ជាប់ និងបង់ថ្លៃចុះឈ្មោះ ដែលកំណត់ដោយ <b>ន.ម.ក.</b> ឱ្យបាន ១៥ (ដប់ប្រាំ) ថ្ងៃមុនសុពលភាពចាស់ផុតកំណត់។</p>
          <!--  eslint-enable no-use-before-define  -->
        </div>
      </div>
    </div>

</div>

</template>

<script>
export default {
  methods: {
    changeLanguage() {
      console.log(this.$i18n.locale);
      this.$i18n.locale = this.$i18n.locale == "en" ? "kh" : "en";
    },
    clickRegister() {
      if (typeof this.$store.getters.getAuth.access_token === "undefined") {
        this.$router.push({ name: "SingUp" });
      } else {
        this.$router.push({ name: "register" });
      }
      //
    },
    handleScroll(){
      if(this.$route.name == 'Home'){
        if(window.scrollY>=120){
          if(!this.$store.getters.getTempalte.headerScroll){
            this.$store.commit('changeTemplate',{
              headerScroll: 'navbar-transparent-scroll'
            });
          }
        }else{
          if(this.$store.getters.getTempalte.headerScroll){
              this.$store.commit('changeTemplate',{
                headerScroll: ''
              });
          }
        }
      }
    }
  },
  created () {
    //window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* navbar-transparent */
.bcover{
  display: block;
  position: absolute;
  background: #333;
  height: 110vh;
  border: 1px;
  width: 100%;
  opacity: 0.7;
  z-index: 1;
}
.top {
  color: #fff;
  /* width: 70%; */
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 1000;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 70px;
}

.block{
  color: #fff;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bgcover {
  background: url("~@/assets/images/bg.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
  top: 0;
  left: 0;
}

.pf {
  font-size: 18px;
  text-align: justify;
  letter-spacing: -1px;
}

.bg-gray{
  background-color: #f1f1f1;
}

.bg-gray .container{
  background-color: #f1f1f1;
}

@media (max-width: 613px) {
  h3,
  h4,
  button {
    font-size: 14px;
  }
  .top {
    width: 100%;
    padding: 40px;
  }
}
</style>
